import {styled} from '@mui/material/styles';
import {Box} from "@mui/material";

/**
 * A 'fixed' box that covers the entire screen
 */
const FixedBox = styled(Box)(({theme}) => ({
    top: 0,
    left: 0,
    position: "fixed",
    height: "100%",
    width: "100%",
    backgroundColor: theme.palette.background.default,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    zIndex: 10000,
}));

export {FixedBox}